import { Ref } from 'react';
import {
  DetailCalculatorWithLocalStorage,
  DetailCalculatorWithLocalStorageProps as DetailCalculatorWithLocalStorageOriginalProps,
  CalculatorState,
  OldDetailCalculatorWithLocalStorage,
} from '../../components/Calculator';

export type DetailCalculatorWithLocalStorageProps =
  DetailCalculatorWithLocalStorageOriginalProps & {
    calculatorRef?: Ref<CalculatorState>;
    old?: boolean;
  };

const DetailCalculatorWithLocalStorageWrapper = ({
  old,
  calculatorRef,
  ...props
}: DetailCalculatorWithLocalStorageProps) => {
  return old ? (
    <OldDetailCalculatorWithLocalStorage {...props} />
  ) : (
    <DetailCalculatorWithLocalStorage ref={calculatorRef} {...props} />
  );
};

export default DetailCalculatorWithLocalStorageWrapper;
